import { useSyncExternalStore } from "react";
import { OrganizationRoleType } from "../../autogen/bff-api";

/**
 * A UI-only preview of what the app looks like with a narrower role, for admins checking role-based
 * visibility without reassigning anyone's roles. Never widens access: `useSub` only applies it when
 * the real user is an owner/admin, and the backend still authorizes by the real roles.
 *
 * Deliberately not a Redux slice: `useSub` reads it, and `useSub` must stay renderable without a
 * store Provider (many component tests render its consumers bare). In-memory only, so a reload
 * always returns to the real roles.
 */
let viewAsRole: OrganizationRoleType | null = null;
const listeners = new Set<() => void>();

export const setViewAsRole = (role: OrganizationRoleType | null) => {
  viewAsRole = role;
  listeners.forEach((listener) => listener());
};

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const useViewAsRole = () => useSyncExternalStore(subscribe, () => viewAsRole);
